var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.active,{tag:"component",attrs:{"data":_vm.data},on:{"changeStatus":_vm.changeStatus}})
}
var staticRenderFns = []

export { render, staticRenderFns }